import { render, staticRenderFns } from "./_Basic.vue?vue&type=template&id=8c9eeadc&scoped=true&"
import script from "./_Basic.vue?vue&type=script&lang=js&"
export * from "./_Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9eeadc",
  null
  
)

export default component.exports